let dt_index = null;
let dt_submenu = null;
let microsite_id = null;

export function index(params){

    dt_index = $('#tags_table').DataTable({
        ajax: {
            url: $('#tags_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_tags_actions },
            { width: '20', data: 'visibility', class: 'px-0', orderable: false, searchable: false , render: render_tags_visible},
            { width: '50', data: 'order', class: 'text-right', orderable: true, searchable: true },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [3, 'asc'],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_tags"]').click(batch_delete_tags);
    });

    // dt_index.on('draw', function(e, settings){
    //     $(settings.nTableWrapper).find('.update_active').click(update_active);
    // });

    microsite_id = params.microsite_id;
}

function render_tags_actions(data, type, row){

    const url_info = ($("#tags_table").attr('url_info') ?? '').replace('#', row.id);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
        '</div>';

    return actions;

}

function render_tags_visible(data, type, row){

    let visibility = '<div class="btn-group" role="group">';

    switch (row.visible) {

        case 'hidden':
            visibility +='   <button class="btn btn-default btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-eye-slash"></i></button>';
            break;

        case 'visible':    
            visibility +='   <button class="btn btn-primary btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-eye"></i></button>';
            break;

        case 'only_guest':
            visibility +='   <button class="btn btn-secondary btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user-secret"></i></button>';
            break;

        case 'only_users':
            visibility +='   <button class="btn btn-info btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user"></i></button>';
            break;

        case 'only_health':
            visibility +='   <button class="btn btn-success btn-xs btn-visibility visibility disabled" title="' + window.__(row.visibility) + '"><i class="fa-solid fa-user-doctor"></i></button>';
            break;
            
    }
                
    visibility += '</div>';
    return visibility;
    
}

export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

function batch_delete_tags(){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.tags.batch_delete'].replace('{microsite}', microsite_id);
    
    let tags_id = [];
    $.each(rows_selected, function(index, rowId){
        tags_id.push(rowId);
    });
    
    if(tags_id.length == 0){

        window.messages.error(__('No has seleccionado ningúna etiqueta'));

    } else {

        const title = __('Eliminar tags');
        const text = 
            trans_choice('{1} Estás a punto de eliminar una etiqueta.|[2,*] Estás a punto de eliminar :count etiquetas.', tags_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let tag_id of tags_id){
                        formData.append('tags_id[]', tag_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}

export function create(params){
    microsite_id = params.microsite_id;
    init_type_selector();
}

export function show(params){
    microsite_id = params.microsite_id;
    init_type_selector();
}

function init_type_selector(){

    $('select[name="type"]')
        .change(function(){

            let type = $(this).val();
            
            $('.value.' + type).show();
            $('.value:not(.' + type + ')').hide();

            $('.value').removeClass('d-none');

        })
        .trigger('change');

}